import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/sale-contracts', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/v1/sale-contracts/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/sale-contracts', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/sale-contracts/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = (id, data) => {
  return httpClient
    .put(`/api/v1/sale-contracts/${id}/delete`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const toPdf = id => {
  return httpClient
    .get(`/api/v1/sale-contracts/${id}/to-pdf`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const product = (Options = {}) => {
  return httpClient
    .get('/api/v1/sale-contracts/products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const status = () => {
  return httpClient
    .get('/api/v1/sale-contracts/status')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const customer = (Options = {}) => {
  return httpClient
    .get('/api/v1/sale-contracts/customers', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const exFx = () => {
  return httpClient
    .get('/api/v1/sale-contracts/exchange-rates')
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getBalance = data => {
  return httpClient
    .post('/api/v1/sale-contracts/product-balances', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formModel = (options = {}) => {
  return httpClient
    .get('/api/v1/sale-contracts/form-view-models', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  get,
  find,
  store,
  update,
  destroy,
  product,
  toPdf,
  customer,
  status,
  exFx,
  formModel,
  getBalance
}
